// extracted by mini-css-extract-plugin
export default {"switch":"SliderCheckbox_switch__DfodK","slider":"SliderCheckbox_slider__U-eNx","round":"SliderCheckbox_round__9d3qH"};